export const defaultFormData = {
  // propertyDetails: {
  //   "Hotel Name": "",
  //   Address: "",
  //   "Locality & Pincode": "",
  //   "Distance from International Airport": "",
  //   "Distance from Domestic Airport": "",
  //   "Distance from Railway Station": "",
  //   "Hotel Website": "",
  //   "Year Built": "",
  //   "Recent Renovation Year": "",
  //   Latitude: "",
  //   Longitude: "",
  //   "Star Category": "",
  //   "Nearest Public Transport & Distance from hotel": "",
  //   "Type of Accomodation": "",
  //   "Hotel Description": "",
  // },
  propertyDetails: {
  hotelName: "",
  address: "",
  locality: "",
  pinCode: "",
  city: "",
  state: "",
  country: "",
  hotelPhone: "",
  // Country code for hotelPhone (number only); joined before sending.
  hotelPhoneCode: "",
  hotelPhoneIso: "",
  hotelEmail: "",
  hotelWebsite: "",
  hotelDescription: "",
  currency: "INR",
  distanceIntlAirport: "",
  distanceDomesticAirport: "",
  distanceRailwayStation: "",
  distancePublicTransport: "",
  yearBuilt: "",
  renovationYear: "",
  latitude: "",
  longitude: "",
  starCategory: "",
  accommodationType: ""
}
  // amenities: {},
  // policies: {
  //   "24 hrs Check-In": "No",
  //   "24 hrs Check-Out": "No",
  //   "Standard Check-In Time": "",
  //   "Standard Check-Out Time": "",
  //   "Early Check-In": "",
  //   "Late Check-Out": "",
  //   "Visitors Allowed": "",
  //   "Pets Allowed": "",
  //   "Children allowed in hotel": "",
  //   "Complimentary stay for children until age of 6": "",
  //   "Extra bed required from age of": "",
  //   "Minimum age of Check-in": "",
  //   "Alcohol allowed onsite": "",
  //   "Alcohol Served onsite": "",
  //   "Stag/ bachelor and hen/ bachelorette parties": "",
  //   "Extra bed Charges (Adult)": "",
  //   "Extra bed Charges (Child)": "",
  //   "Cancellation Policy": "",
  // },
  // rooms: [
  //   {
  //     "Room Name": "",
  //     "Room Type": "",
  //     "Maximum Occupancy": "",
  //     "Total Inventory": "",
  //     "Area size (sq.ft)": "",
  //     "Bed Type": "",
  //     "Connecting/Adjoining Rooms": "",
  //     Balcony: "",
  //     Windows: "",
  //     "Room View": "",
  //   },
  // ],
  // competitionHotels: [""],
  // importantContacts: [{ name: "", phone: "", email: "" }],
  // transfers: [
  //   { model: "", pickup: "", chargeable: "No", oneWay: "", twoWay: "" },
  // ],
  // touristInterest: [""],
  // cardsAccepted: [{ cardType: "", accepted: "No" }],
  // roomFacilities: [{ name: "", available: "No", complimentary: "No" }],
  // ratePlans: [
  //   {
  //     "Rate Plan Name": "",
  //     "Rate Plan Type": "",
  //     "Linked Plan": "",
  //     "Linked to": "",
  //     "Sgl Rate": "",
  //     "Dbl Rate": "",
  //     "Rooms Applicable": "",
  //     Inclusions: "",
  //     "Minimum length of stay": "",
  //     "Maximum length of stay": "",
  //     "Lead Time": "",
  //     "Cancellation Policy": "",
  //     "Members only deal": "",
  //   },
  // ],
  // fbOptions: [{ name: "", cuisine: "", type: "", timings: "", meals: "" }],
};
